/**
 * Do things with header on scroll
 * 
 * @see http://jsfiddle.net/mariusc23/s6mLJ/31/
 * @since 1.0.0
 * @package lockbusters
 */
(function($) {
	$(document).ready(function() {
		if ($(window).width() <= 850) {

		var didScroll;
		var header			= $( 'header[role="banner"]' );
		var lastScrollTop	= 0;
		var delta			= 5;
		var navbarHeight	= header.outerHeight();

		// watch for scrolling
		$( window ).scroll( function(e) {
			didScroll = true;
		});


		// check this stuff every 250ms
		setInterval( function() {
			if ( didScroll ) {
				hasScrolled();
				didScroll = false;
			}
		}, 250 );


		/**
		 * Figure out of the header needs to be moved
		 */
		function hasScrolled() {

			var st = $( this ).scrollTop();

			// make sure they scroll more than delta
			if ( Math.abs( lastScrollTop - st ) <= delta ) {
				return;
			}

			// If they scrolled down and are past the navbar, add class
			// .nav-up. This is necessary so you never see what is
			// "behind" the navbar.
			if (
				( st > lastScrollTop && st > navbarHeight ) &&
				! header.hasClass( 'mobile-menu-open' )
			) {

				// scroll down
				header.removeClass( 'nav-down' ).addClass( 'nav-up' );
			}
			else {
				// scroll up
				if ( st + $( window ).height() < $( document ).height() ) {
					header.removeClass( 'nav-up' ).addClass( 'nav-down' );
				}
			}

			lastScrollTop = st;
		}


		/**
		 * Scroll from top detection
		 */
		$(document).on( 'scroll', function() {

			if ( $(document).scrollTop() > 80 ) {
				header.addClass( 'scrolled' );
			} else {
				header.removeClass( 'scrolled' );
			}
		});
	}

	}); // document.ready()
})(jQuery);